import React from "react";
import { Typography } from "@mui/material";
import { Typography as FTypography, Stack } from "@financeable-com-au/financeable-ui";
import { useGetLocalAndLenderErrors } from "@/hooks/useRequiredFields/useGetLocalAndLenderErrors";
import { ID_TYPE } from "../../../src/constants";

const LicencePassportToggle = ({ allValues, setAllValue, handleSaveIDType, isDisable }) => {
  const handleToggle = (value) => {
    setAllValue({
      ...allValues,
      IDType: value,
    });
    handleSaveIDType(value);
  };

  const { getCustomerOrEntityLocalAndLenderError } = useGetLocalAndLenderErrors();
  const getLocalAndLenderError = ({ fieldName, localFieldName }) => {
    return getCustomerOrEntityLocalAndLenderError({ fieldName: "IDType", localState: {} });
  };

  return (
    <Stack direction="column" alignItems="center" textAlign="center">
      {allValues?.IDType === ID_TYPE.LICENCE ? (
        <Stack direction="column" alignItems="center" textAlign="center">
          <Typography
            variant="body2"
            color={"primary"}
            disabled={isDisable}
            onClick={() => !isDisable && handleToggle(ID_TYPE.PASSPORT)}
            sx={{
              display: "inline",
              cursor: "pointer",
              fontWeight: "normal",
            }}
          >
            Use {ID_TYPE.PASSPORT}
          </Typography>
          {!!getLocalAndLenderError({ fieldName: "IDType" }) && (
            <FTypography level="body-xs" textColor="danger.200">
              {getLocalAndLenderError({ fieldName: "IDType" })}
            </FTypography>
          )}
        </Stack>
      ) : (
        <Stack direction="column" alignItems="center" textAlign="center">
          <Typography
            variant="body2"
            color={"primary"}
            disabled={isDisable}
            onClick={() => !isDisable && handleToggle(ID_TYPE.LICENCE)}
            sx={{
              display: "inline",
              cursor: "pointer",
              fontWeight: "normal",
            }}
          >
            Use {ID_TYPE.LICENCE}
          </Typography>
          {!!getLocalAndLenderError({ fieldName: "IDType" }) && (
            <FTypography level="body-xs" textColor="danger.200">
              {getLocalAndLenderError({ fieldName: "IDType" })}
            </FTypography>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default LicencePassportToggle;
